module.exports = __webpack_public_path__ + "static/oab-ef1ac6bdac17b592ee57454f7df81efc.png";